import * as React from 'react';
import { compose, isDefined } from '@grandvisionhq/utils';
import { ProductListingRow } from '../../../components/ProductListingRow/ProductListingRow.js';
import '@swc/helpers';
import { withBloomreachData } from '../../../hocs/with-bloomreach-data.js';
import '@bloomreach/react-sdk';
import '../../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../../utils/http-client.js';
import '@grandvisionhq/state';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../../operations/mutations/signup-promotion.js';
import '../../../operations/mutations/subscribe-newsletter.js';
import '../../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../../hooks/use-breakpoint-visibility.js';
import { withEditableContent } from '../../../hocs/with-editable-content.js';
import { extractSkusFromBrParameters, generateConditionalClassNames } from '../utils/utils.js';

/**
 * This variant of the ProductListingRow component is used for the RowComponent, to
 be dragged & dropped in a RowColumn
 */ const CmsRowProductListBySku = ({ component  })=>{
    const parameters = component.getParameters();
    const { horizontalAlignment , verticalAlignment  } = parameters;
    const skus = extractSkusFromBrParameters(parameters);
    const rowSkuClassName = generateConditionalClassNames('br-row-sku', {
        horizontalAlignment,
        verticalAlignment
    });
    if (!isDefined(skus) || skus.length === 0) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: rowSkuClassName,
        "data-t": "br-row-sku"
    }, /*#__PURE__*/ React.createElement(ProductListingRow, {
        skus: skus
    }));
};
var RowProductListBySku = compose(withBloomreachData, withEditableContent)(CmsRowProductListBySku);

export { CmsRowProductListBySku, RowProductListBySku as default };
//# sourceMappingURL=RowProductListBySku.js.map
